<template>
  <v-card
    v-click-outside="handleFocusOut"
    flat
    tabindex="-1"
  >
    <div class="input-size">
      <input
        id="filter-text"
        v-model="searchName"
        class="input outlined-input"
        placeholder="Name"
        :type="filter.type"
        autofocus
        @input="validate(searchName)"
        @keyup.enter="applyFilters()"
      >
    </div>
    <FilterSpecButtons
      @close-filter-specification="$emit('close-filter-specification')"
      @apply-filters="applyFilters"
    />
  </v-card>
</template>

<script>
import FilterSpecButtons from './FilterSpecButtons.vue';

export default {
  name: 'FilterSpecText',
  components: {
    FilterSpecButtons,
  },
  props: {
    filter: {
      type: Object,
      required: true,
    },
    collection: {
      type: String,
      required: false,
      default: '',
    },
  },
  emits: ['close-filter-specification', 'update-filters'],
  data() {
    return {
      filteredData: [],
      searchName: null,
    };
  },
  mounted() {
    this.searchName = this.filter.searchName ?? null;
  },
  methods: {
    applyFilters() {
      const filter = {
        ...this.filter,
        searchName: this.searchName,
      };
      this.$emit('update-filters', filter);
      this.$emit('close-filter-specification');
    },
    validate(input) {
      // if input is empty, return null to prevent attempts to parse empty string to number
      if (input === '') return null;
      const inputString = input.toString();
      return inputString;
    },
    /** Handles logic when focus is lost. */
    handleFocusOut() {
      // Don't do anything if a child element is focused
      if (this.$el.matches(':focus-within')) return;
      this.$emit('close-filter-specification');
    },
  },
};
</script>

<style scoped lang="scss">
.input {
  width: 100%;
  height: 40px;
  padding-right: 10px;
}
.input-size {
  width: 100%;
}
</style>
